const ROOT = '/school';
const Path = {

    HOME: ROOT + "",
    DASHBOARD: ROOT + '/dashboard',
    ENGAGEMENT_REPORT: ROOT + '/engagementreport',
    VERIFY: ROOT + '/verify',
    UPDATE_PASSWORD: ROOT + '/update-password',
    FORGOT_PASSWORD: ROOT + '/forgot-password',
    LOGIN: ROOT + '/login',
    ADMIN: ROOT + '/admin',
    CONTACTS: ROOT + '/contacts',
    TEACHERS: ROOT + '/teachers',
    CLASSES: ROOT + '/classes',
    PROFILE: ROOT + '/profile',
    CONFIRM_PROFILE: ROOT + '/confirm-profile',
    HOMEWORK: ROOT + '/homework',
    QUICK_VIEW: ROOT + '/quick/view',
    STANDARD_HOMEWORK: ROOT + '/standard/homework',
    STANDARD_CLASS_WORKS: ROOT + '/standard/classworks',
    MERIT_LEADERBOARD: ROOT + '/merit/leaderboard',


    HOMEWORK_COMPLETION_REPORT: ROOT + '/standard/homework/completionreport/',
    HOMEWORK_EVALUATION_REPORT: ROOT + '/standard/homework/homeworkevaluationreport/',
    MOST_WRONG_REPORT : ROOT + '/standard/homework/mostwrongreport/',
    ELO_LEVEL_REPORT : ROOT + '/standard/homework/elolevelreport/',

    


    PERSONALISED_HOMEWORK: ROOT + '/personalised/homework/adaptive',
    PERSONALISED_CLASS_WORK: ROOT + '/personalised/homework/adaptiveclasswork',

    TEST: ROOT + '/test',
    CLASS_WORK_TEST: ROOT + '/classworktest',

    ASSESSMENT_RESULTS_REPORT : ROOT + '/test/assessmentresults/',
    TEST_COMPLETION_REPORT : ROOT + '/test/testcompletionreport/',
    TEST_WRONG_ANSWER_REPORT : ROOT + '/test/testwronganswerreport/',
    TEST_ALL_QUESTIONS_REPORT : ROOT + '/test/testallquestionsreport/',


    ASSESSMENT: ROOT + '/assessment',
    SIGNUP: ROOT + '/signup',
    USERS_SIGNUP: ROOT + '/users/signup',
    GULF_SIGNUP: ROOT + '/signup/gulf',
    RMS_SIGNUP: ROOT + '/signup/rms',
    CSF_SIGNUP: ROOT + '/signup/csf',
    MPL_SIGNUP: ROOT + '/signup/mpl',
    FLC_SIGNUP: ROOT + '/signup/flc',
    MSF_SIGNUP: ROOT + '/signup/msf',
    PUBLIC_COMPONENT : ROOT + '/publiccomponent',
    //CMO_SIGNUP: ROOT + '/signup/cmosignup',
    CMO_SIGNUP: '/cmosignup',
    DEMO_REQUEST: '/demorequest',
    NMD_SIGNUP: '/nmd2023',
    FFL_SIGNUP : '/fflcurriculum',
    PERFORMANCE: ROOT + '/performance',
    STUDENTS: ROOT + '/students',
    ONBOARD: ROOT + '/onboarding',
    USERS: ROOT + '/users',
    EVENTS: ROOT + '/events',
    SCHOOLS: ROOT + '/schools',
    SUBJECT_SELECTION: ROOT + '/subject-selection',
    PAT_NOTIFICATION: ROOT + '/pat/notification/:code/:id/:classes',
    PARENT_PAT_NOTIFICATION: ROOT + '/pat/notification/:parentId/all',
    HOMEWORK_NOTIFICATION: ROOT + '/homework/notification/:homeworkId',
    HOMEWORK_ASSIGN: ROOT + '/students/homework/assign/:code/:eventId',
    HOMEWORK_ASSIGN_V2: ROOT + '/students/homework/assign',
    CLAIM_FORM: ROOT + '/students/claim/form/:id',
    QUESTION_BANK: ROOT + '/question-bank',
    LEARNING_RESOURCES: ROOT + '/learning-resources',
    WORKSHEETS_LIST : ROOT + '/worksheets-list',
    EDIT_TEACHER_PROFILE: ROOT + '/edit-teacher-profile',
    MMS_CLAIM_FORM: ROOT + '/students/may2022/claim/form/:id',
    MPL_2022_CLAIM_FORM: ROOT + '/students/mpl2022/claim/form/:id',
    MSF_2022_CLAIM_FORM :ROOT + '/students/msf2022/claim/form/:id',
    MMS_JUNE_22_CLAIM_FORM: ROOT + '/students/june2022/claim/form/:id',
    FLC_CLAIM_FORM: ROOT + '/students/flc/claim/form/:id',
    HOMEWORK_V2: ROOT + '/homework/v2',
    INVITATION_SUCCESS: ROOT + '/invitation/success',

    DICTIONARY: ROOT + '/dictionary',
    ALL_VIDEOS: ROOT + '/allvideos',
    ALL_ELOS: ROOT + '/allexpectedlearning',
    COORDINATES: ROOT + '/coordinates',
    TEACHER_DASHBOARD: ROOT + '/teacherdashboard',
    PERFORMANCE_REPORT: ROOT + '/studentperformancereport',

    //Jigyasa Assign Assessment

    ASSING_ASSESSMENT: ROOT + '/assignassessment',
    VIEW_ASSESSMENT: ROOT + '/viewassessment',
    DIAGNOSTIC_ASSESSMENT_LIST : ROOT + '/diagnosticassessmentlist',
    DIAGNOSTIC_ASSESSMENT : ROOT + '/diagnosticassessment',

    CLICKER_ASSESSMENT: ROOT + '/clickerassessment',
    CLICKER_QUIZ : ROOT + '/clickerquiz',

    CLICKER_PRACTICE : ROOT + '/clickerpractice',
    CONCEPT_CARDS : ROOT + '/conceptcards',

    ALL_SCHOOL_CLICKERS: ROOT + '/allschoolclickerslist',

    STUDENT_ENGAGEMENT_REPORT : ROOT + '/studentengagementreport',
    STUDENT_LOGOUT_REPORT : ROOT + '/studentlogoutreport',
    MASTER_SCHOOLWORK : ROOT + '/masterschoolwork'



};

export default Path;